import { h } from 'preact';
import React, { Component } from 'react';
import SearchSVG from '../Components/Search.svg';
import Accordion from '../Components/Accordion';
import { VendorContent } from './VendorContent';
import { makeText } from '../../../util';
import { lockedVendors } from '../../../constants';

export default class Vendors extends Component {
  state = {
    filter: '',
    selected: this.props.startWithLiToggled ? 'li' : 'consent',
  }

  updateFilter = (e) => this.setState({ filter: e.target.value });

  render() {
    const { vendors, settings, language, dev, usePurModel } = this.props;
    const { filter, selected } = this.state;

    const filteredVendors = vendors
      .filter(v => selected === 'consent' ? v.consentCategories.length : (v.legIntCategories.length || v.disclosureOnlyCategories.length))
      .filter(v => filter === '' || v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);

    const searchText = makeText(Boolean(dev), settings, 'searchText', language);
    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);
    const consentText = makeText(Boolean(dev), settings, 'vendorConsentText', language);
    const liText = makeText(Boolean(dev), settings, 'vendorLiText', language);
    const appleDataBrokerText = makeText(Boolean(dev), settings, 'appleDataBrokerText', language);
    const appleDataBrokerLetter = makeText(Boolean(dev), settings, 'appleDataBrokerLetter', language);
    
    return (
      <div className="pm-features pm-vendors">
        <div className="pm-type-toggle">
          <div onClick={() => this.setState({ selected: 'consent' })}>{consentText}</div>
          <div onClick={() => this.setState({ selected: 'li' })}>{liText}</div>
          <span className={selected === 'li' ? 'selected li' : 'selected consent'} />
        </div>
        <div className="filter-container">
          <img src={SearchSVG} alt="" />
          <input className="vendor-filter" placeholder={`${searchText}...`} name="filter" value={filter} onChange={this.updateFilter} />
        </div>
        <div className="legend"><span className="legend-key">{otherLetter}</span> {otherText}{appleDataBrokerLetter && <span className="legend-key apple-broker">{appleDataBrokerLetter}</span>} {appleDataBrokerText}</div>
        {filteredVendors.map(v => {
          const canToggle = v.disclosureOnlyCategories.length > 0 && v.legIntCategories <= 0 && v.consentCategories <= 0 ? false : true;
          const specialToggle = (v.iabSpecialPurposes.length > 0 || v.iabFeatures.length > 0) && v.consentCategories <= 0 && v.iabSpecialFeatures <= 0 ? true : false;
          const isApple = v.isApple;
          return (
            <Accordion
              key={`vendor-${v.vendorId}`}
              settings={this.props.settings}
              name={<span>{v.name}{v.vendorType !== 'IAB' && <span className="legend-key inline">{otherLetter}</span>}</span>}
              isCustom={v.vendorType !== 'IAB'}
              locked={lockedVendors.includes(v.iabId)}
              description={v.name}
              child="vendors"
              language={language}
              value={v}
              content={<VendorContent dev={dev} vendor={v} settings={settings} language={language} consentType={selected} />}
              toggle={canToggle && !specialToggle ? this.props.toggleVendor : null}
              consentType={selected === 'consent' ? 'active' : 'legInt'}
              selected={selected === 'consent' ? 'active' : 'li'}
              isApple={isApple}
              appleDataBrokerLetter={appleDataBrokerLetter}
              usePurModel={usePurModel && this.state.selected !== 'li'}
            />
          );
        }
        )}
      </div>
    );
  }
}
